/* eslint-disable no-empty-pattern */
import kitsu from '@plugins/kitsu';
import http from '@plugins/axios';

let $ajax = kitsu({ baseURL: process.env.VUE_APP_API_URL + '/psp/gtk/dpp-pengawas' });

export const state = {};

export const mutations = {};

export const actions = {
  async fetch({}) {
    return await $ajax.get('/');
  },

  async candidate({}, payloads) {
    return await $ajax.get('/kandidat', { params: payloads.params });
  },

  async lookup({}, payloads) {
    return await $ajax.get(`/fetch/${payloads.id}`);
  },

  actions({}, payloads) {
    const url = `/psp/gtk/dpp-pengawas/${payloads.endpoint}`;
    return http.post(url, payloads.params).then(({ data }) => data);
  },
};
